import type { FaceKey } from '@repo/api-contracts';

/** 면 이름 — 편집기 면 탭·썸네일과 견적 디자인 뷰어 면 탭이 함께 쓴다. */
export const FACE_LABELS: Readonly<Record<FaceKey, string>> = {
  front: '앞면',
  back: '뒷면',
  left: '왼쪽',
  right: '오른쪽',
};
